import { useState } from 'react'
import { useLoad } from '../../../../../../shared/hooks/load'
import { useApiListProviderHealth, useApiListProviderDomain, useApiListProviderOrganinization, useApiListProviderClaimMapping } from '../../../../../../api-new/state/auth'

// Everything the strip and the routing/claims sections read besides the
// provider row itself. Each list is undefined while it loads (the strip and
// sections say "Loading…") and null if it fails (they say it couldn't be
// loaded, rather than showing a zero).
export const useConnectionData = providerID => {
  const healthApi = useApiListProviderHealth()
  // provider-domain filters by query string. useApiList's get(arg) joins
  // `${endpoint}/${arg}`, so the query goes on the hook's endpoint and get()
  // takes no argument (get('?providerID=…') would request provider-domain/?…).
  const domainApi = useApiListProviderDomain(`?providerID=${providerID}`)
  const linkApi = useApiListProviderOrganinization()
  const mappingApi = useApiListProviderClaimMapping()
  const [data, setData] = useState({ health: undefined, domains: undefined, links: undefined, mappings: undefined })

  // Lists default to [] (an empty answer is zero rows); health is one row,
  // so a missing row stays null and the strip says "Unavailable".
  const settle = async (key, fn, empty = []) => {
    try {
      const value = await fn()
      setData(d => ({ ...d, [key]: value || empty }))
    } catch (e) {
      setData(d => ({ ...d, [key]: null }))
    }
  }

  const reload = {
    // The health tile tolerates a missing row, so health is the row or null.
    health: () => settle('health', async () => ((await healthApi.get()) || []).find(r => r.providerID === providerID) || null, null),
    domains: () => settle('domains', () => domainApi.get()),
    links: () => settle('links', () => linkApi.get(`${providerID}/provider`)),
    mappings: () => settle('mappings', () => mappingApi.get(`${providerID}/provider`))
  }
  reload.all = () => Promise.all([reload.health(), reload.domains(), reload.links(), reload.mappings()])

  useLoad(() => { if (providerID) reload.all() }, [providerID])

  return { ...data, reload }
}
